import styled from "styled-components";

export const ReportJobsWrapper = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    gap: 20px;
`;

export const TableWrapper = styled.div`
    flex: 1;
    height: calc(100vh - 400px);
    display: flex;
    flex-direction: column;
    /* overflow: hidden; */
`;

export const ActionsContainer = styled.div`
    display: flex;
    gap: 10px;
    justify-content: flex-end;
`;

export const EmptyWrapper = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
`;

export const BadgeWrapper = styled.div``;